import React, { ReactElement } from 'react';
import classNames from 'classnames';
import CardBlockSC from './PaymentBlock.styled';
import CardBlock from 'components/blocks/CardBlock';
import { useTranslation } from 'utils/localization';
import H3 from 'components/typography/H3';

interface Props {
    amount: number;
    bankAccount: string;
    variableSymbol: string;
    noMargin?: boolean;
    hideTitle?: boolean;
}

const PaymentDetailsBlock = ({
    amount,
    bankAccount,
    variableSymbol,
    noMargin,
    hideTitle,
}: Props): ReactElement => {
    const { t } = useTranslation();

    return (
        <CardBlockSC>
            <CardBlock
                className={classNames('root', noMargin ? 'noMargin' : '')}
            >
                <div>
                    {!hideTitle && <H3>{t('Payment.payment') as string}</H3>}
                    <div>
                        {bankAccount && (
                            <div>
                                <span>{t('Payment.accNumber')}:</span>
                                <b>{bankAccount}</b>
                            </div>
                        )}
                        {variableSymbol && (
                            <div>
                                <span>{t('Payment.vs')}:</span>
                                <b>{variableSymbol}</b>
                            </div>
                        )}
                        {amount && (
                            <div>
                                <span>{t('Payment.amount')}:</span>
                                <b>{amount} Kč</b>
                            </div>
                        )}
                    </div>
                </div>
            </CardBlock>
        </CardBlockSC>
    );
};

export default PaymentDetailsBlock;
